import React from 'react'

import './styles.scss'
import ButtonRounded from 'components/ButtonRounded'

const ButtonMsPay = props => (
  <ButtonRounded
    icon="ms_pay"
    as="button"
    bgClassName="bg--black"
    wrapperClassName="btn--payment"
    iconColor="transparent"
    wrapperProps={props}
  />
)

export default ButtonMsPay
